export default function ProtocolRelativeFilter () {
  return function (input) {
    if (typeof input !== 'string') return input;

    if (input.indexOf('https://') === 0 || input.indexOf('http://') === 0) {
      do {
        input = input.substring(1);
      } while (input.indexOf('//') > 0);
    }

    return input;
  }
};



// WEBPACK FOOTER //
// ./source/client/filters/protocol-relative.js